import { Document } from '@vi-iot/client';

export interface DocumentsState {
  documents: Document[];
  documentsUpdated: Document[];
  xotaMode: XotaMode | null;
  xotaLoading: boolean;
}

export enum XotaMode {
  xOTA = 'xOTA',
  xOTA_security = 'xOTA-security',
  None = 'none',
}
